export const t = (key) => window.__autocompleteTranslations?.[key] || key
